<div class="logo-trademark">
    <img [src]="branding.logoWhiteAsset" [alt]="branding.title">
    <span class="txt">{{branding.title}}, All Rights Reserved © {{currentYear}}</span>
</div>
